import { render, staticRenderFns } from "./MenuFormView.vue?vue&type=template&id=565e591e&scoped=true&"
import script from "./MenuFormView.vue?vue&type=script&lang=js&"
export * from "./MenuFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565e591e",
  null
  
)

export default component.exports